// extracted by mini-css-extract-plugin
export var arg = "syntax-guide-module--arg--bb115";
export var argToken = "syntax-guide-module--argToken--20556";
export var args = "syntax-guide-module--args--7343c";
export var functionToken = "syntax-guide-module--functionToken--5cdfd";
export var keywordArg = "syntax-guide-module--keywordArg--5406c";
export var keywordName = "syntax-guide-module--keywordName--85450";
export var keywordType = "syntax-guide-module--keywordType--b0ea4";
export var optional = "syntax-guide-module--optional--cac4b";
export var statementToken = "syntax-guide-module--statementToken--0ea62";
export var syntaxGuide = "syntax-guide-module--syntaxGuide--55a59";
export var variadic = "syntax-guide-module--variadic--d96d0";